import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import LandingPage from "./views/LandingPage.vue";
import Error from "./views/Error.vue";
import ContactUs from "@/views/ContactUs";
import PrestonMosquesForAlAqsa from "@/views/PrestonMosquesForAlAqsa.vue";
import DeathPenaltyLaw from "@/views/DeathPenaltyLaw.vue";
import SolarPathWidgetPlayground from "@/views/SolarPathWidgetPlayground.vue";
import PrivacyPolicies from "@/views/PrivacyPolicies";
import LivestreamAppPrivacyPolicy from "@/views/privacy_policies/LivestreamAppPrivacyPolicy";
import ListProducts from "@/views/privacy_policies/ListProducts";
import LivestreamIframePrivacyPolicy from "@/views/privacy_policies/LivestreamIframePrivacyPolicy";
import LivestreamAlexaPrivacyPolicy from "@/views/privacy_policies/LivestreamAlexaPrivacyPolicy";
import LivestreamTermsOfService from "@/views/terms_of_services/LivestreamTermsOfService";
import LivestreamAlexaTermsOfService from "@/views/terms_of_services/LivestreamAlexaTermsOfService";
import ListProductsForTermsOfServices from "@/views/terms_of_services/ListProducts";
import TermsOfServices from "@/views/TermsOfServices";

Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        header: AppHeader,
        default: LandingPage,
        footer: AppFooter,
      },
    },
    {
      path: "/contact-us",
      name: "contact-us",
      components: {
        header: AppHeader,
        default: ContactUs,
        footer: AppFooter,
      },
    },
    {
      path: "/preston-mosques-for-al-aqsa",
      name: "preston-mosques-for-al-aqsa",
      components: {
        header: AppHeader,
        default: PrestonMosquesForAlAqsa,
        footer: AppFooter,
      },
    },
    {
      path: "/discriminatory-death-penalty-law",
      name: "discriminatory-death-penalty-law",
      components: {
        header: AppHeader,
        default: DeathPenaltyLaw,
        footer: AppFooter,
      },
    },
    {
      path: "/solar-path-playground",
      name: "solar-path-playground",
      components: {
        header: AppHeader,
        default: SolarPathWidgetPlayground,
        footer: AppFooter,
      },
    },
    {
      path: "/privacy-policies",
      name: "privacy-policy",
      redirect: "/privacy-policies",
      components: {
        header: AppHeader,
        default: PrivacyPolicies,
        footer: AppFooter,
      },
      children: [
        {
          path: '/',
          name: 'privacy-policy.list',
          component: ListProducts
        },
        {
          path: "livestream-app",
          name: "privacy-policy.livestream-app",
          component: LivestreamAppPrivacyPolicy,
        },
        {
          path: "livestream-iframe",
          name: "privacy-policy.livestream-iframe",
          component: LivestreamIframePrivacyPolicy,
        },
        {
          path: "livestream-alexa",
          name: "privacy-policy.livestream-alexa",
          component: LivestreamAlexaPrivacyPolicy,
        },
      ],
    },
    {
      path: "/terms-of-services",
      name: "terms-of-service",
      redirect: "/terms-of-services",
      components: {
        header: AppHeader,
        default: TermsOfServices,
        footer: AppFooter,
      },
      children: [
        {
          path: "/",
          name: "terms-of-service.list",
          component: ListProductsForTermsOfServices
        },
        {
          path: "livestream",
          name: "terms-of-service.livestream",
          component: LivestreamTermsOfService,
        },
        {
          path: "livestream-alexa",
          name: "terms-of-service.livestream-alexa",
          component: LivestreamAlexaTermsOfService,
        },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      name: "error",
      components: {
        header: AppHeader,
        default: Error,
      },
    },
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
